import React from 'react';

const Spinner: React.FC = () => (
  <div className="flex items-center justify-center p-4" role="status" aria-label="Loading">
    <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-black/10 border-t-[#2F80ED] dark:border-[rgba(132,151,190,0.16)] dark:border-t-[#67D8E8]" />
  </div>
);

export default Spinner;
